import { createTheme } from '@mui/material/styles';
import { PRIMARY_MAIN, SECONDARY_MAIN } from './utilities/constants';

const theme = createTheme({
  palette: {
    primary: { main: PRIMARY_MAIN },
    secondary: { main: SECONDARY_MAIN },
  },
  typography: {
    fontFamily: "'Lato', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
      },
    },
  },
});

export default theme;
